import { Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserAuthHttpService } from '@core/http/user-auth.http.service';
import { timer } from 'rxjs';
import { finalize, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-mfa-info-modal',
  templateUrl: './mfa-info-modal.component.html',
  styleUrls: ['./mfa-info-modal.component.scss'],
  standalone: false,
})
export class MfaInfoModalComponent {
  public dialogRef = inject(MatDialogRef<MfaInfoModalComponent>);
  private readonly userAuthHttpService = inject(UserAuthHttpService);
  private readonly minLoadingTime = 500;

  public loading = false;
  public stopMfaInfoWindow = false;

  public close(goToSettings: boolean): void {
    if (this.loading) {
      return;
    }

    this.dialogRef.close(goToSettings);
  }

  public changeStopMfaInfoWindow(stopMfaInfoWindow: boolean): void {
    if (this.loading) {
      return;
    }

    const previousValue = this.stopMfaInfoWindow;
    this.loading = true;
    this.dialogRef.disableClose = true;
    this.stopMfaInfoWindow = stopMfaInfoWindow;

    timer(this.minLoadingTime)
      .pipe(
        switchMap(() => this.userAuthHttpService.stopMfaInfoWindow(stopMfaInfoWindow)),
        finalize(() => {
          this.loading = false;
          this.dialogRef.disableClose = true;
        })
      )
      .subscribe({
        error: () => {
          this.stopMfaInfoWindow = previousValue;
        },
      });
  }
}
